import { defineTable } from "convex/server";
import { v } from "convex/values";
import { notificationSettingsValidator } from "../system/notifications/preferences";

// Nuevos tipos para multi-empresa
export const companyStatus = v.union(
  v.literal("active"),
  v.literal("inactive"),
  v.literal("suspended"),
);

export const validatorCompany = v.object({
  // new fields (didn't exist in old version)
  name: v.string(), // Nombre de la empresa
  description: v.optional(v.string()), // Descripción de la empresa
  legalName: v.optional(v.string()), // Razón social completa
  taxId: v.optional(v.string()), // RTN o identificación fiscal
  nrc: v.optional(v.string()), // NRC (Número de Registro de Contribuyente)
  email: v.optional(v.string()), // Email principal de la empresa
  phone: v.optional(v.string()), // Teléfono principal
  address: v.optional(v.string()), // Dirección física
  city: v.optional(v.string()), // Ciudad
  state: v.optional(v.string()), // Estado/Departamento
  country: v.optional(v.string()), // País
  website: v.optional(v.string()), // Sitio web
  logoId: v.optional(v.id("_storage")), // Logo de la empresa
  status: v.optional(companyStatus), // active/inactive/suspended
  // Configuración empresarial
  defaultCurrency: v.optional(v.string()), // Moneda por defecto (HNL, USD, etc.)
  defaultTaxRate: v.optional(v.number()), // Tasa de impuesto por defecto
  paymentTerms: v.optional(v.string()), // Términos de pago por defecto
  defaultProfitMargin: v.optional(v.number()), // Margen de ganancia por defecto
  // Notificaciones
  notificationSettings: v.optional(notificationSettingsValidator),
  // Modo debug a nivel empresa: activa las dev-tools para todos sus usuarios.
  // Lo controla un super administrador desde la tabla de empresas.
  debugMode: v.optional(v.boolean()),
  // Visibilidad de datos maestros (clientes, productos, servicios).
  // "company": compartidos entre todas las branches (default, retrocompatible).
  // "branch": cada branch tiene su propio conjunto.
  masterDataScope: v.optional(
    v.union(v.literal("company"), v.literal("branch")),
  ),
  // Limite de sesiones concurrentes por usuario para esta empresa. Si esta
  // ausente o es null, no hay override a nivel empresa (la cascada usa el
  // limite del plan; si el plan tampoco lo define, sin limite salvo el hard
  // cap del sistema). Al excederse, la sesion mas antigua se revoca
  // automaticamente al iniciar sesion una nueva. `null` es la senal explicita
  // de "limpiar override" desde la UI (campo vacio).
  maxConcurrentSessions: v.optional(v.union(v.number(), v.null())),
  // Plataformas a las que los usuarios de esta empresa pueden acceder. Si
  // esta ausente, hereda de subscription_plans.allowedPlatforms (default: todas).
  allowedPlatforms: v.optional(
    v.array(
      v.union(
        v.literal("web"),
        v.literal("ios"),
        v.literal("android"),
        v.literal("desktop"),
      ),
    ),
  ),
  // «Pasar a la nube» (solo escritorio): cuándo se exportó la empresa para
  // llevarla a la nube. Mientras esté puesto, el escritorio queda en solo
  // lectura (`lib/readonly/cloud_migration_guard.ts`). En la nube no se usa.
  migratedToCloudAt: v.optional(v.number()),
  // Timestamps
  createdAt: v.optional(v.number()),
  updatedAt: v.optional(v.number()),
});

export const companies = defineTable(validatorCompany)
  .index("by_status", ["status"])
  .index("by_tax_id", ["taxId"])
  .index("by_name", ["name"])
  .index("by_migrated_to_cloud_at", ["migratedToCloudAt"])
  .searchIndex("search_companies", {
    searchField: "name",
    filterFields: ["status"],
  });
